import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addUserActivity, togglePreference, updateActivityTimer, updateTimer } from "../../../redux/slices/userActivity";
import { getTime } from "../../../utils";
import Dropdown from "../../Dropdown";

import styles from './styles.module.css'

const dropdowndata = [
   {
      id: 1,
      value: 'On Video timeline'
   },
   {
      id: 2,
      value: 'Pre Video'
   },
   {
      id: 3,
      value: 'Post Video'
   },
]

export const PreferenceModal = () => {
   const dispatch = useDispatch();

   const { preferenceActive, userActivities, defaultPreference, preferenceEditing } = useSelector((state) => state.userActivity);
   const [minutes, setMinutes] = useState(0)
   const [seconds, setSeconds] = useState(5)
   const [videoTimelinePref, setVideoTimelinePref] = useState(1)

   const [timerDisabled, setTimerDisabled] = useState(false)

   // console.log('defaultPreference', defaultPreference);
   // console.log('preferenceEditing', preferenceEditing);
   // console.log('videoTimelinePref', videoTimelinePref);

   useEffect(() => {
      const timestamp = getTime(defaultPreference.timestamp)
      console.log('time', timestamp);
      setMinutes(timestamp.minutes)
      setSeconds(timestamp.seconds)
      handleChange(defaultPreference.dropdownId)
   }, [defaultPreference])

   const handleClose = () => {
      dispatch(togglePreference({ preferenceActive: false }))
   };
   // console.log('userActivities', userActivities)
   const [dropDownData, setDropDownData] = useState(dropdowndata)


   const handleChange = (id) => {
      // console.log('id', parseInt(id));
      if (parseInt(id) === 2) {
         setTimerDisabled(true)
         setMinutes(0)
         setSeconds(0)
      } else if (parseInt(id) === 3) {
         setTimerDisabled(true)
      }
      else {
         setTimerDisabled(false)
      }
      setVideoTimelinePref(parseInt(id))
      // dropDownData.map(item => {
      //    if (item.id === id) {
      //       setVideoTimelinePref(item.id)
      //    }
      // })
   }

   const handleSubmit = () => {
      let timer = 0
      let mins = parseInt(minutes)
      let secs = parseInt(seconds)
      timer = secs
      if (minutes !== 0 && typeof mins === 'number' && !isNaN(mins)) {
         timer = timer + mins * 60
      }
      if (videoTimelinePref === 2) {
         timer = 0
      } else if (videoTimelinePref === 3) {
         timer = -1
      }
      console.log('timestamp', timer)
      // return
      if (preferenceEditing === false) {
         console.log('not editing');
         dispatch(addUserActivity({ question_id: { timestamp: timer } }))
      } else {
         console.log('editing');
         dispatch(updateActivityTimer({ timestamp: timer }))
      }
      handleClose()
   }


   return (
      <>
         <AnimatePresence>
            {preferenceActive && (
               <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5, type: "tween", ease: "anticipate" }}
                  className={styles.modal_wrapper}
                  onClick={handleClose}
               >
                  <motion.div
                     initial={{ scale: 0.5 }}
                     animate={{ scale: 1 }}
                     exit={{ scale: 0.5 }}
                     transition={{ duration: 0.5, type: "tween", ease: "anticipate" }}
                     className={styles.content_wrapper}
                     onClick={(e) => e.stopPropagation()}
                  >
                     <div className={styles.container}>
                        <div>
                           <p className={styles.heading} >Slide Preferences</p>
                           <p className={styles.para} >Where do you want to add the slide?</p>
                        </div>
                        <div className={styles.dropdown}>
                           <Dropdown data={dropDownData} onChange={handleChange} initialSelectedItem={videoTimelinePref} />
                        </div>
                        <div>
                           <p className={styles.timestamp}>
                              At what time of the video?
                              <span className={styles.timestampText}>
                                 Timestamp
                              </span>
                           </p>
                        </div>
                        <div className={`${styles.inputContainer} ${timerDisabled ? styles.disabled : ''}`}>
                           <div className={styles.wrapper}>
                              <div style={{ display: 'flex', justifyContent: 'center', position: 'relative' }}>
                                 <div className={styles.minute}>
                                    <p className={styles.placeholderText}>m</p>
                                    <input type='number' className={styles.inputLeft}
                                       value={minutes}
                                       disabled={timerDisabled}
                                       onChange={e => setMinutes(e.target.value)} />
                                 </div>
                                 :
                                 <div className={styles.minute}>
                                    <p className={styles.placeholderText}>s</p>
                                    <input type='number' className={styles.inputRight}
                                       value={seconds} disabled={timerDisabled}
                                       onChange={e => setSeconds(e.target.value)} />
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div className={styles.buttons}>
                           <button className='btn btn-primary' onClick={handleSubmit} >
                              Apply
                           </button>
                           <button className='btn btn-primary' onClick={handleClose} >
                              Cancel
                           </button>
                        </div>


                     </div>

                     <div className={styles.close_icon} onClick={handleClose}>
                        <img src="/assets/icons/close.svg" alt="" />
                     </div>
                  </motion.div>
               </motion.div>
            )}
         </AnimatePresence>
      </>
   );
};
